module.exports = __webpack_public_path__ + "static/img/18.6d4fa63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/18.png
// module id = IwI4
// module chunks = 0